// UI slice — Isomorphism Phase 2 · Blind Spot 1 (AppState slicing)
//
// Global UI state: theme, locale, sidebar. Components READ these but
// only the kernel (settings / user action) WRITES them.
//
// Design: slice factory pattern — each slice is a standalone function
// that returns { getState, setState } scoped to its domain. The root
// store in index.ts combines all slices via Zustand's composition.

import type { StateCreator } from 'zustand';

export type ThemeMode = 'light' | 'dark' | 'system';

export interface UiSlice {
  /** Active theme. 'system' follows OS preference. */
  theme: ThemeMode;
  /** Sidebar collapsed state (course sub-routes). */
  sidebarCollapsed: boolean;

  // Actions (only these should modify UiSlice state)
  setTheme: (theme: ThemeMode) => void;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const createUiSlice: StateCreator<UiSlice> = (set) => ({
  theme: 'system',
  sidebarCollapsed: false,

  setTheme: (theme) => set({ theme }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
});
